import { PaymentMethodEnum } from "@edp-enums/payment-method.enum";
import { MonthlyInvoice } from "@edp-models/billing.model";
import { ChallengeLevelResponse } from "@edp-models/challenge-level.model";
import { Action } from "@ngrx/store";

export enum EBillingActions {
    GetMontlhyInvoices = "[Billing] Get monthly invoices",
    SetMontlhyInvoices = "[Billing] Set monthly invoices",
    SetPaymentTab = "[Billing] Set payment tab",
    GetTariffFiles = "[Billing] Get tariff files",
    SetTariffFiles = "[Billing] Set tariff files"
}

export class GetMontlhyInvoices implements Action {
    public readonly type = EBillingActions.GetMontlhyInvoices;
    constructor(public contractId: string) {}
}

export class SetMontlhyInvoices implements Action {
    public readonly type = EBillingActions.SetMontlhyInvoices;
    constructor(public payload: MonthlyInvoice[]) {}
}

export class GetTariffFiles implements Action {
    public readonly type = EBillingActions.GetTariffFiles;
    constructor(public payload: any) {}
}

export class SetTariffFiles implements Action {
    public readonly type = EBillingActions.SetTariffFiles;
    constructor(public payload: []) {}
}


export class SetPaymentTab implements Action {
    public readonly type = EBillingActions.SetPaymentTab;
    constructor(public payload: PaymentMethodEnum) {}
}

export type BillingActions = GetMontlhyInvoices
    | SetMontlhyInvoices
    | GetTariffFiles
    | SetTariffFiles
    | SetPaymentTab;
